module.exports = __webpack_public_path__ + "img/info-icon.4af82103.svg";